import { useEffect, useState } from "react";
import { Container } from "../../../utils/CustomComponents";

function Counter() {
    return (
        <div id="counter">
            <Container>
                <div className="grid">
                    <Count text="Registered Companies" count={51} />
                    <span></span>
                    <Count text="Registered Staffs" count={101} />
                    <span></span>
                    <Count text="Paid Pensioners" count={41} />
                </div>
            </Container>
        </div>
    );
}

export default Counter;

function Count({ count, text }) {
    const [counter, setCounter] = useState(0);
    const [startCount, setStartCount] = useState(false);
    var c = 0;
    useEffect(() => {
        // This useEffect just starts the counter
        // when user scrolls to the counter section
        const counts = document.getElementById("counter");
        window.addEventListener("scroll", () => {
            if (window.scrollY >= counts.offsetTop - 600) {
                setStartCount(true);
            }
        });
        window.addEventListener("load", () => {
            if (window.scrollY >= counts.offsetTop - 600) {
                setStartCount(true);
            }
        });
        return () => {
            setCounter(0);
            setStartCount(false);
        };
    }, []);

    useEffect(() => {
        if (startCount) {
            let s;
            // basic counter up
            s = setInterval(() => {
                if (c >= count) {
                    clearInterval(s);
                }
                setCounter(c++);
            }, 4000 / count);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [startCount]);
    return (
        <div className="grid_item">
            <span className="number">{counter}</span>
            <h3>{text} </h3>
        </div>
    );
}
